import * as tournament from './tournament'

export * as tournament from './tournament'

export const actions = {
  ...tournament.actions,
}

export const epics = [...tournament.epics]

export const { reducer } = tournament
